import { Button } from 'components/ui'
import { useTable } from 'context/table-context'
import classNames from 'helpers/class-names'
import { FC, useMemo } from 'react'

interface Props {
  emptyButtonLabel?: string
  emptyButtonText?: string
  onClickEmptyButton?: () => void
}

const TableEmpty: FC<Props> = ({
  emptyButtonLabel = 'No items to display',
  emptyButtonText,
  onClickEmptyButton,
}) => {
  const { isEmpty, footer } = useTable()
  const showButton = useMemo(() => {
    return Boolean(
      typeof emptyButtonText === 'string' &&
        emptyButtonText !== '' &&
        typeof onClickEmptyButton === 'function',
    )
  }, [emptyButtonText, onClickEmptyButton])

  if (!isEmpty) {
    return <></>
  }

  return (
    <div className="flex h-full min-h-32 w-full flex-row items-center">
      <div
        className={classNames(
          'flex w-full flex-col items-center gap-2.5 text-center text-sm font-semibold text-gray-400',
          { 'pb-10': Boolean(footer) },
        )}>
        <label htmlFor={showButton ? 'empty-table-button' : undefined}>
          {emptyButtonLabel}
        </label>
        {showButton && (
          <Button
            id={'empty-table-button'}
            onClick={onClickEmptyButton}
            className="mx-auto">
            {emptyButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default TableEmpty
